import API from 'common/API'
import Connect from 'common/Connect'
import { SubsChannelProducts, SubsChannelProductsParams } from 'models/SubsChannelProducts'
import { SubsProduct, SubsProductParams } from 'models/SubsProduct';

export const SubsApiAction = {
    async getSubsProducts(userId: string): Promise<SubsChannelProducts> {
        const response = await Connect.get(API.v5External, `/subs-channels/${ userId }/subs-products`, {});
        return toSubsChannelProducts(response.data);
    },

    async getMySubsProducts(): Promise<SubsChannelProducts> {
        const response = await Connect.get(API.v5Authorized, `/subs-channels/me/subs-products`, {});
        return toSubsChannelProducts(response.data?.data?.items)
    },
    
    async getIsMySubsOpen(): Promise<boolean> {
        const response = await Connect.get(API.v5Authorized, `/subs-channels/me`, {})
        const status = response?.data?.data?.items?.[0]?.status
        return status === 'OPENED' || status === 'SUSPENDED' || status === 'CLOSING'    
    }
}

const toSubsChannelProducts = (response: any) => {
    const params: SubsChannelProductsParams = {
        items: response?.map((item: any) => toSubsProduct(item)) ?? []
    };
    return new SubsChannelProducts(params);
}


const toSubsProduct = (response: any) => {
    const params: SubsProductParams = {
        id: response.id,
        name: response.name ?? '',
        tier: response.tier ?? 0
    };
    return new SubsProduct(params);
}


